/* global globalThis */
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import PropTypes from "prop-types";
import queryString from "query-string";
import {Container, Nav, Navbar} from "react-bootstrap";
import {ROUTES} from '../../utils/navigationItems';
import PopulationSearch from "./components/populationSearch";
import Messages from "./components/messages";
import Account from "./components/account";
import {getMessageCount} from "../../actions/admin/header/messageActions";
import BroadcastNewReleaseNoteMessage from "../admin/broadcastMessenger/BroadcastNewReleaseNoteMessage";

const componentName = "Header";
const IGNORE_PAGE_TITLE_LIST = new Set(["Patient Profile"]);

const Header = ({ sidebarExpanded, setSidebarExpanded }) => {
  const [pageTitle, setPageTitle] = useState('');

  const dispatch = useDispatch();
  const quickListState = useLocation();

  useEffect(() => {
    dispatch(getMessageCount());
  }, [dispatch]);

  const { count } = useSelector((state) => state.messages);

  useEffect(() => {
    const handleWorklistTitleEvent = () => {
      const title = globalThis.localStorage.getItem("worklistTitle");
      if (pageTitle === "Worklist") {
        setPageTitle("Worklist " + title);
      }
    };

    globalThis.addEventListener("worklistTitleEvent", handleWorklistTitleEvent);
    return () => {
      globalThis.removeEventListener("worklistTitleEvent", handleWorklistTitleEvent);
    };
  }, [pageTitle]);

  useEffect(() => {
    let localTitle = quickListState.state ? quickListState.state.pageTitle : '' ;
    const urlString = globalThis.location.href;
    const index = urlString.indexOf("?");
    if (index >= 0) {
      const paramsMeta = urlString.substring(index);
      const params = queryString.parse(paramsMeta);
      if (params.customListName) {
        setPageTitle(params.customListName);
      }
    }

    if(!localTitle){
      const pathName = quickListState.pathname || '' ;
      Object.entries(ROUTES).forEach(([key,value])=>{
        if(value && pathName && value.path && value.path.replaceAll("/", "") === pathName.replaceAll("/", "")){
          localTitle = key;
        }
      });
    }

    const currentRoute = globalThis.location.pathname;
    if (currentRoute !== '/patient-profile') {
      setPageTitle(localTitle);
    }

    if(!IGNORE_PAGE_TITLE_LIST.has(pageTitle)){
      setPageTitle(localTitle)
    }
  }, [quickListState, pageTitle]);

  return (
    <Navbar bg="white" expand="lg" id="mainHeader" className="header">
      <BroadcastNewReleaseNoteMessage />
      <Container fluid>
        <div className="d-flex justify-content-start align-items-center">
          {!sidebarExpanded && (
            <button type="button" className="cursor-p me-3 btn btn-link p-0 border-0 bg-transparent text-dark"
              aria-label="Open Sidebar" onClick={() => setSidebarExpanded(true)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setSidebarExpanded(true);
                }
              }}
            >
              <i className="fa-regular fa-bars fa-lg"></i>
            </button>
          )}
          <span id={`${componentName}-pageTitle`} className="h4 fw-bold mb-0">{pageTitle}</span>
        </div>
        <div className="d-flex justify-content-start align-items-center">
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="ms-auto my-2 my-lg-0 flex-row align-items-center">
              <Navbar.Text>
                <PopulationSearch />
              </Navbar.Text>
            </Nav>
          </Navbar.Collapse>
          <div>
            <Messages count={count} />
            <Account />
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

Header.propTypes = {
  sidebarExpanded: PropTypes.bool.isRequired,
  setSidebarExpanded: PropTypes.func.isRequired,
};

export default Header;
